module.exports = __webpack_public_path__ + "static/turtle-creek-house24-09e401c1084fac1592142ef3abb5cde2.jpg";